module.exports = __webpack_public_path__ + "media/images/bg/patterns/activities/2-b90c3dcf7db5b42d4ed814e68532c3a4.svg";